import  AppUtil  from '@/util/AppUtil';

// import {Toast} from 'vant'
/**全局单例数据*/
export default class AppVo {
    // [x: string]: any;
    /**服务分类列表*/
    private serveSorArr:any[]=[]
    

    private static instance: AppVo; //类型为这个类
   
    static getInstance() {
        if (!this.instance) {
          this.instance = new AppVo();
        }
        return this.instance;
    }
    appid="";
    /**
     * 购物车数据
     * code 为0时是未请求数据或者数据出错
     */
    private cart:{code:number,count:number,data:any[]}={count:0,data:[],code:0};
    /**是否正在请求购物车数据，防止同时触发多个请求 */
    private carting:boolean=false;
    /** 选中的服务列表 */
    public serveArr:any[]=[];
    /** 当前用户的超级会员数据 */
    public shareholder!:{id:number};
    /**格式化服务分类数据*/
    set serveSortList(val:any[]){
        // const arr:any[]=[];
        val.map(sort=>{
           sort.text=sort.sortName;
           sort.childrenList.splice(0,0,{id:0,sortName:"全部"})
        });
        if(val.length){
            if(val[0].id){
                val.splice(0,0,{id:0,text:"全部",childrenList:[{id:"",sortName:"全部"}]})
            }
        }
        
        
        this.serveSorArr=val;
    }
    get serveSortList(): any[]{
        return  this.serveSorArr;
    }
    /**套餐分类 */
    private packSortArr:any[]=[];
    /**格式化套餐分类数据*/
    set packSortList(val:any[]){
        // const arr:any[]=[];
        val.map(sort=>{
           sort.text=sort.sortName;
           sort.childrenList.splice(0,0,{id:0,sortName:"全部"})
        });
        if(val.length){
            if(val[0].id){
                val.splice(0,0,{id:0,text:"全部",childrenList:[{id:"",sortName:"全部"}]})
            }
        }
        
        this.packSortArr=val;
    }
    get packSortList(): any[]{
        return  this.packSortArr;
    }
    public get cartInfo(){
        if(this.cart.code==0&&!this.carting){
            this.req_cartList();
        }
        return this.cart;
    }
    /**请求购物车信息 */
		private req_cartList() {
            this.carting=true;
			AppUtil.request({
					url: "/zhMember/shopCart/getShopCartList",
					method: "post",
					data: {
						page: 1,
						limit: 10
					}
				},
				(res: any) => {
					console.log("购物车信息", res);
					this.cart = res;
				},"",()=>{
                    this.carting=false;
                }
			);
		}
}
